import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../styles/CalendarioReservas.css';
import useDropdownData from '../hooks/useDropdownData';
import useObtenerCitaPorFecha from '../hooks/useObtenerCitaPorFecha';
import DocumentViewer from './DocumentViewer';
import { construirFechaSinHoraExtra, formatearHora, urlApi } from '../helpers/functionHelpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faClock, faFile, faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const CalendarioReservas = () => {
  const navigate = useNavigate();
  const [dataCita, setDataCita] = useState({
    cab_id: '',
    fechaRsv: '',
    dataIni: '',
    dataFin: '',
    AlmacenAsignado_id: '',
  });
  const [almacen, setAlmacen] = useState({
    id:'',
    ubicacion: '',
    descripcion: ''
  });
  const [citasOrdenadas, setCitasOrdenadas] = useState([]);
  const [expandedFolio, setExpandedFolio] = useState(null);
  const { data: ubicacions, loading: loadingUbicacions, error: errorUbicacions } = useDropdownData(`${urlApi}/api/ubicacions`, setAlmacen, almacen.id, true);
  const { citas, loading: loadingCitas, error: errorCitas } = useObtenerCitaPorFecha(dataCita.AlmacenAsignado_id, construirFechaSinHoraExtra(dataCita.fechaRsv));

  const handleAlmacenChange = (e) => {
    setCitasOrdenadas([]);
    setAlmacen(e.target.value);
    setDataCita((prevData) => ({
      ...prevData,
      AlmacenAsignado_id: e.target.value
    }));
  };
  const handleDateChange = (date) => {
    setCitasOrdenadas([]);
    setDataCita((prevData) => ({
      ...prevData,
      fechaRsv: date,
    }));
  };

  const handleRowClick = (cita) => {
    const folio = cita.folio || cita.cab_id;
    navigate(`/admin/calendario/${folio}`);
  };

  useEffect(() => {
    if (citas && citas.length > 0) {
      const citasOrdenadasPorHorario = [...citas].sort((a, b) => new Date(a.dataIni) - new Date(b.dataIni));
      setCitasOrdenadas(citasOrdenadasPorHorario);
    }
  }, [citas]);

  return (
    <div className="calendario-reservas-container">
      <h2>Calendario de reservas</h2>
      <div className="contenido-calendario">
        <div className="sidebar">
          <div className="form-group">
            <label htmlFor="almacen">Almacén:</label>
            {loadingUbicacions ? (
              <p>Cargando ubicaciones...</p>
            ) : errorUbicacions ? (
              <p>Error: {errorUbicacions}</p>
            ) : (
              <select id="almacen" name="almacen" value={almacen.id} onChange={handleAlmacenChange}>
                <option value="Seleccione">Seleccione</option>
                {ubicacions.map((ubicacion) => (
                  <option key={ubicacion.id} value={ubicacion.id}>
                    {ubicacion.descripcion} {ubicacion.nombreEmpresa ? `(${ubicacion.nombreEmpresa})` : ''}
                  </option>
                ))}
              </select>
            )}
          </div>
          <Calendar
            onChange={handleDateChange}
            value={dataCita.fechaRsv}
            className="custom-calendar"
          />
        </div>

        <div className="lista-citas">
          <h3>Citas del día</h3>
            {loadingCitas ? (
                <p>Cargando citas...</p>
              ) : errorCitas ? (
                <p>Error al cargar citas: {errorCitas}</p>
              ) : citas.length > 0 ? (

            <table className="tabla-citas">
              <thead>
                <tr>
                  <th>Folio</th>
                  <th>Horario</th>
                  <th>Nombre</th>
                  <th>Correo</th>
                  <th>Insumo</th>
                  <th>Documentos</th>
                </tr>
              </thead>
              <tbody>
                {citasOrdenadas.map((cita) => {
                  const folio = cita.folio || cita.cab_id;
                  return (
                    <React.Fragment key={cita.cab_id}>
                      <tr onClick={() => handleRowClick(cita)} className="clickable-row">
                        <td><FontAwesomeIcon icon={faFile} style={{ marginRight: '8px', color: '#d32f2f' }} />{cita.folio || "Reserva interna"}</td>
                        <td><FontAwesomeIcon icon={faClock} style={{ marginRight: '8px', color: '#d32f2f' }} />{`${formatearHora(cita.dataIni)} - ${formatearHora(cita.dataFin)}`}</td>
                        <td><FontAwesomeIcon icon={faUser} style={{ marginRight: '8px', color: '#d32f2f' }} />{cita.nombrePrv || 'N/A'}</td>
                        <td><FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px', color: '#d32f2f' }} />{cita.correoPrv || 'N/A'}</td>
                        <td><FontAwesomeIcon icon={faSquarePlus} style={{ marginRight: '8px', color: '#d32f2f' }} />{cita.nmInsumo || 'N/A'}</td>
                        <td>
                          {cita.folio && (
                            <button 
                              className="expand-button-small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setExpandedFolio(expandedFolio === folio ? null : folio);
                              }}
                            >
                              {expandedFolio === folio ? 'Ocultar' : 'Ver'}
                            </button>
                          )}
                        </td>
                      </tr>
                      {expandedFolio === folio && cita.folio && (
                        <tr>
                          <td colSpan="6" className="document-cell">
                            <DocumentViewer folio={cita.folio} />
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No hay citas para este día.</p>
          )}
        </div>
      </div>
    </div>

  );
};

export default CalendarioReservas;
